import { ChartOptions, ColorType, CrosshairMode, LineType, LineWidth } from 'lightweight-charts'
import { background, green, red } from './colors'
import {
    AreaSeriesOptions,
    BarSeriesOptions,
    CandlestickSeriesOptions,
    HistogramSeriesOptions,
    HollowCandleSeriesOptions,
    LineSeriesOptions,
    PlotTypesMenuItemType,
    RenkoSeriesOptions,
    LineBreakSeriesOptions,
    VolumeCandleSeriesOptions
} from '../components/chartV2/chart.typings'
import { defaultVolumeCandleOptions } from "../components/chartV2/customSeries/volumeCandleSeries/options";
import { IndicatorOutput_OutputStyle } from '../proto/generated/indicator'
import { ChartSubType, ChartType } from '../proto/generated/chart'
import { ScalperLayouts } from '../pages/scalper/scalper.typings';
import { PredefinedDashboard } from '../components/widgetDashboard/widgetDashboard.enums';

export const SECURITY_URL_PARAM = 'symbol'
export const FNO_VIEW_URL_PARAM = 'fnotab'
export const LAYOUT_URL_PARAM = 'layout'
export const EXP_FILTER_DELIMTER = '|'
export const API_BASE_LOCAL_SERVER = '192.168.0.150:8080'
export const STATIC_IP_ADDRESS = '3.6.6.34'
export const API_BASE_SERVER = import.meta.env.VITE_API_BASE_SERVER
// eslint-disable-next-line eqeqeq
const API_SCHEME = import.meta.env.VITE_USE_SSL == 'true' ? 'https://' : 'http://'
export const API_BASE_URL = API_SCHEME + API_BASE_SERVER

// eslint-disable-next-line eqeqeq
const WS_SCHEME = import.meta.env.VITE_USE_SSL == 'true' ? 'wss://' : 'ws://'
export const WEB_SOCKET_URL = WS_SCHEME + API_BASE_SERVER + '/app'
export const SUPER_CHARTS_CONFIG_URL = API_BASE_URL + '/supercharts/configuration'
export const SUPER_CHARTS_CALENDER = API_BASE_URL + '/supercharts/trading-calendar/all'
export const GOOGLE_CLIENT_ID = '341190729175-gqc8j1t397bb9k5628dp8tvo63dpvsfn.apps.googleusercontent.com'
export const X_CLIENT_ID = 'WjVHcTNDMmtZQTk3UVV0Tm5oVjQ6MTpjaQ'
export const X_CODE_CHALLENGE = 'challenge'
export const X_TOKEN_URL = 'https://api.twitter.com/2/oauth2/token'
export const X_CLIENT_SECRET = '4nJASHGbkPJUamLI7rMv2qtWozd95bjgXmJDYy0L_lHAyGVl8d'
export const WATCHLIST_URL = API_BASE_URL + '/watchlists'
export const TOKEN_VALIDATE_URL = API_BASE_URL + '/auth/oauth/token/validate'
export const GET_LOGIN_URL = API_BASE_URL + '/auth/login-url'
export const GET_ADD_TRADING_ACCOUNT_URL = API_BASE_URL + '/trading-accounts/login-url'
export const CONNECT_TRADING_ACCOUNT_URL = API_BASE_URL + '/trading-accounts/connect'
export const GET_SECURITY_OVERVIEW_URL = API_BASE_URL + '/securities/overview'
export const GET_GLOBAL_COLUMN_SETS_URL = API_BASE_URL + '/screener/meta/global-column-sets'
export const GET_SECURITY_SNAPSHOT = API_BASE_URL + '/tickdata/security-snapshot'
export const GET_GLOBAL_COLUMN_URL = API_BASE_URL + '/screener/meta/global-screener-columns'
export const GET_SCREENER_FIELDS_URL = API_BASE_URL + '/screener/meta/screener-fields'
export const SECURITIES_SCAN_URL = API_BASE_URL + '/securities/scan'
export const INDICATOR_SCRIPT_URL = API_BASE_URL + '/indicators/script'
export const SECURITIES_LOOKUP_URL = API_BASE_URL + '/securities/lookup'
export const SECURITIES_CATEGORIES_URL = API_BASE_URL + '/securities/categories'
export const MARKET_NEWS_URL = API_BASE_URL + '/marketnews'
export const CREATE_ALERT_URL = API_BASE_URL + '/alerts'
export const GET_OPTION_CHAIN_EXPIRIES = API_BASE_URL + '/options/expiries'
export const TRADING_ACCOUNTS_URL = API_BASE_URL + '/trading-accounts'
export const MARGINS_URL = API_BASE_URL + '/trading-accounts/margins'
export const GET_OPTION_CHAIN = API_BASE_URL + '/options/optionchain'
export const GET_FUTURES = API_BASE_URL + '/futures'
export const GET_FIRED_ALERTS = API_BASE_URL + '/alerts/fired/all '
export const GET_ORDER_BOOK = API_BASE_URL + '/tickdata/order-book'
export const GET_ORDER_BOOKS = API_BASE_URL + '/tickdata/order-books'
export const GET_ALERTS = API_BASE_URL + '/alerts/all '
export const MASTER_LOADER_HOST_URL = 'http://192.168.0.150:9090'
export const GOOGLE_AUTH_SCOPE = 'https://www.googleapis.com/auth/userinfo.email%20https://www.googleapis.com/auth/userinfo.profile'
export const ACCESS_TOKEN = 'accessToken'
export const REFRESH_TOKEN = 'refreshToken'
export const IS_PIN_ENABLED_KEY = 'tick2trade_is_pin_enabled'
export const LOGIN_SESSION_WINDOW_UNTIL_KEY = 'tick2trade_login_window_until'
export const PIN_UNLOCK_LOGIN_SESSION_KEY = 'tick2trade_pin_unlock_login'
export const DEVICE_ID_STORAGE_KEY = 'tick2trade_web_device_id'
export const IS_NEW_USER = 'isNewUser'
export const LOGIN_TIME = 'loginTime'
export const SCALPER_LAYOUT_ID = 'scalper'
export const SCALPER_LAYOUT_UPDATE_KEY = 'scalperLayoutUpdateTime'
export const SCALPER_DEFAULT_LAYOUT = ScalperLayouts.SPOT_CALL_OR_PUT
export const SCALPER_DEFAULT_PREDEFINED_LAYOUT = PredefinedDashboard.LAYOUT_H2

export const VITE_API_BASE_URL_STRAPI = import.meta.env.VITE_API_BASE_URL_STRAPI

// export const OAUTH2_REDIRECT_URI = import.meta.env.VITE_BASE_OAUTH2_REDIRECT_URL
export const GOOGLE_OAUTH_REDIRECT_URI = import.meta.env.VITE_GOOGLE_OAUTH_REDIRECT_URL
export const X_OAUTH_REDIRECT_URI = import.meta.env.VITE_X_OAUTH_REDIRECT_URL
export const FYRES_OAUTH_REDIRECT_URI = import.meta.env.VITE_FYRES_OAUTH_REDIRECT_URL
export const ZERODHA_OAUTH_REDIRECT_URI = import.meta.env.VITE_ZERODHA_OAUTH_REDIRECT_URL
export const ZERODHA_POSTBACK_URI = import.meta.env.VITE_ZERODHA_POSTBACK_URL
export const UPSTOX_OAUTH_REDIRECT_URI = import.meta.env.VITE_UPSTOX_OAUTH_REDIRECT_URL
export const UPSTOX_POSTBACK_URI = import.meta.env.VITE_UPSTOX_POSTBACK_URL
export const BASE_OAUTH_REDIRECT_URL = import.meta.env.VITE_BASE_OAUTH_REDIRECT_URL
export const UPSTOX_APP_CREATE_URL = import.meta.env.VITE_UPSTOX_CREATE_APP_LINK
export const ZERODHA_APP_CREATE_URL = import.meta.env.VITE_ZERODHA_CREATE_APP_LINK
export const SLACK_WEB_HOOK_URL = import.meta.env.VITE_SLACK_WEB_HOOK_URL
export const DHAN_POSTBACK_URI = import.meta.env.VITE_DHAN_POSTBACK_URL
export const DHAN_LOGIN_URI = import.meta.env.VITE_DHAN_LOGIN_URL
export const DHAN_APP_CREATE_URL = import.meta.env.VITE_DHAN_CREATE_APP_LINK
export const GOOGLE_AUTH_URL = 'https://accounts.google.com/o/oauth2/auth'
export const LOGOS_BASE_URL = 'https://in.tick2trade.com/icons/company-logos/'
export const STRATEGY_LOGOS_BASE_URL = 'https://in.tick2trade.com/icons/strategy/'
export const BROKERS_LOGOS_BASE_URL = 'https://in.tick2trade.com/icons/brokers/'
export const GLOBAL_NOTIFICATION_MEDIA_BASE_URL = 'https://in.tick2trade.com/media/global-notification/'
export const KITE_AUTH_URL = 'https://kite.zerodha.com/connect/login?v=3&api_key=g231crfaozuzdu20'
export const X_AUTH2_URL = 'https://twitter.com/i/oauth2/authorize'
export const X_AUTH_URL = 'https://api.twitter.com/oauth/authorize'
export const DATE_FORMAT = 'DD/MM/YYYY'
export const CHART_DAY_FORMAT = 'YYYY-MM-DD'

export const VOLUME_SCALE = 'volume'
export const VOLUME_INDICATOR_CODE = 'VOLUME'
export const PIVOT_POINTS_CODE = 'PIVOT_POINTS'
export const HEAD_AND_SHOULDERS_CODE = 'HEAD_AND_SHOULDERS'
export const OI_OUTLOOK_INDICATOR_CODE = 'OPEN_INTEREST_OUTLOOK'
export const INITIAL_CANDLE_COUNT = 50
export const DEFAULT_CANDLES_COUNT = 70
export const PREVIOUS_CANDLES_COUNT = 100
export const EXTRA_CANDLES_COUNT = 50
export const CANDLE_THRESHOLD = 50
export const RIGHT_CANDLES_OFFSET = 3
export const BLANK_SERIES_ID = 'blankSeries';
export const SIMULATOR_MIN_DATE_NSE = '2025-01-01'
export const SIMULATOR_MIN_DATE_BSE = '2025-07-04'

export const CORPORATE_ACTION_DRAWING = 'corporateAction'
export const CONTRACT_SWITCH_DRAWING = 'contractSwitch'
export const COMPANY_EVENT_DRAWING = 'companyEvent'
export const CHART_ORDERS_DRAWING = 'chartOrdersActions'
export const CHART_ORDERS_MARKERS_DRAWING = 'orderMarkers'
export const CHART_ALERTS_ON_CHART_DRAWING = 'chartAlertsOnChart'
export const NEWS_ARTICLE_DRAWING = 'newsArticle'
export const SESSION_BREAK_DRAWING = 'sessionBreak'
export const COMMUNITY_SCREENER_PREVIEW = 'community-preview'

export const PRIMARY_TRADING_ACCOUNT_KEY = 'PRIMARY_TRADING_ACCOUNT_KEY'

export enum ViewType {
    SYMBOL = 'symbol',
    SPREAD = 'spread',
    CHART = 'chart',
    OPTION_CHAIN = 'option-chain',
    OPEN_INTEREST_CHANGE = 'open-interest-change',
    OPEN_INTEREST = 'open-interest',
    MULTI_STRIKES_CHART = 'multi-strike-chart',
    STRATEGY_BUILDER = "strategy-builder",
    SIMULATOR = "simulator",
    REPORTS = "reports",
    AUTOMATION = "automation",
    ADD_TRADING_ACCOUNT = "add-trading-account",
    SCALPER = "scalper",
    STRATEGY = "strategy",
    SUBSCRIPTION='subscription',
    FINANCIAL_DATA = 'financial-data',
}

export enum ChartViewKey {
    STOCK = 'stock',
    OPTIONS = 'options',
    FUTURES = 'futures',
    OVERVIEW = 'overview',
    MULTI_STRIKES_CHART = 'multiStrikeChart',
    SYMBOL = 'symbol',
    STRATEGY_CHART = 'strategy-chart',
    SPREAD = 'spread',
    EMBEDDED = 'embedded',
    STRATEGY = "strategy"
}

export enum OptionChainViewKey {
    LIVE = 'live',
    HISTORICAL = 'historical',
    WIDGET = 'widget'
}

/** Live data + trading (includes dashboard widget option chain). */
export const isOptionChainLiveView = (viewKey: OptionChainViewKey) =>
    viewKey === OptionChainViewKey.LIVE || viewKey === OptionChainViewKey.WIDGET

export enum OptionChainViewType {
    TABLE = 'table',
    GRAPH = 'graph'
}

export enum EventTypes {
    SECURITY_CLICKED = 'SECURITY_CLICKED'
}

export enum OpenInterestScreen {
    OI_CHANGE = 'OI_CHANGE',
    OPEN_INTEREST = 'OPEN_INTEREST',
    MULTI_STRIKE = 'MULTI_STRIKE'
}

export enum Segment {
    INDEX_OPTIONS,
    STOCK_OPTIONS,
    INDEX_FUTURES,
    STOCK_FUTURES,
    INDEX_OPTIONS_OICHANGE,
    STOCK_OPTIONS_CHANGE,
    INDEX_FUTURES_CHANGE,
    STOCK_FUTURES_CHANGE,
    CASH_MARKET,
    CASH_MARKET_CHANGE,
}

// export const areaSeriesOptions = {
//     topColor: red,
//     bottomColor: green,
// } as AreaSeriesOptionsPartial;

export const barSeriesOptions = {
    upColor: green,
    downColor: red,
    openVisible: true,
    thinBars: false
} as BarSeriesOptions

export const candleSeriesOptions: CandlestickSeriesOptions = {
    upColor: green,
    downColor: red,
    borderVisible: false,
    wickUpColor: green,
    wickDownColor: red
}
export const hollowCandleSeriesOptions: HollowCandleSeriesOptions = {
    upColorHollow: green,
    downColorHollow: red,
    borderVisibleHollow: false,
    wickVisibleHollow: true,
    wickUpColorHollow: green,
    wickDownColorHollow: red
}

export const renkoSeriesOptions: RenkoSeriesOptions = {
    upColor: green,
    downColor: red,
    borderVisible: true,
    wickVisible: true,
    wickUpColor: green,
    wickDownColor: red,
    boxMethod: 'atr',
    boxSize: 10,
    atr: 14,
    percentage: 1,
    projectionUpColor: "#a9dcc3",
    projectionDownColor: "#f5a6ae",
    projectionUpBorderColor: "#a9dcc3",
    projectionDownBorderColor: "#f5a6ae",
}

export const lineBreakSeriesOptions: LineBreakSeriesOptions = {
    upColor: green,
    downColor: red,
    borderVisible: true,
    lineCount: 3,
    projectionUpColor: "#a9dcc3",
    projectionDownColor: "#f5a6ae",
    projectionUpBorderColor: "#a9dcc3",
    projectionDownBorderColor: "#f5a6ae",
}

export const volumeCandleSeriesOptions: VolumeCandleSeriesOptions = {
    ...defaultVolumeCandleOptions
}

export const histogramSeriesOptions: HistogramSeriesOptions = {
    upColor: "#26a69a80",
    downColor: "#ef535080",
    source: "close"
}

export const lineSeriesOptions: LineSeriesOptions = {
    color: '#2962FF',
    lineType: LineType.Simple,
    source: "close",
    lineWidth: 2
}
export const areaSeriesOptions: AreaSeriesOptions = {
    source: "close",
    lineWidth: 2,
    lineColor: "#33D778",
    topColor: "rgba(46, 220, 135, 0.4)",
    bottomColor: "rgba( 40, 221, 100, 0)"
}

export const PlotTypesMenu: PlotTypesMenuItemType[] = [
    {
        label: 'Line',
        subType: ChartSubType.SIMPLE,
        style: IndicatorOutput_OutputStyle.SOLID,
        type: ChartType.LINE,
        disabled: false
    }, {
        label: 'Dotted Line',
        subType: ChartSubType.SIMPLE,
        style: IndicatorOutput_OutputStyle.DOTTED,
        type: ChartType.LINE,
        disabled: true
    }, {
        label: 'Dashed Line',
        subType: ChartSubType.SIMPLE,
        style: IndicatorOutput_OutputStyle.DASHED,
        type: ChartType.LINE,
        disabled: true
    }, {
        label: 'Large Dashed Line',
        subType: ChartSubType.SIMPLE,
        style: IndicatorOutput_OutputStyle.LARGE_DASHED,
        type: ChartType.LINE,
        disabled: true
    }, {
        label: 'Sparse Dotted Line',
        subType: ChartSubType.SIMPLE,
        style: IndicatorOutput_OutputStyle.SPARSE_DOTTED,
        type: ChartType.LINE,
        disabled: true
    }, {
        label: 'Line with breaks',
        subType: ChartSubType.SIMPLE,
        style: IndicatorOutput_OutputStyle.WITH_BREAKS,
        type: ChartType.LINE,
        disabled: false
    }, {
        label: 'Step line',
        subType: ChartSubType.STEP_LINE,
        style: IndicatorOutput_OutputStyle.SOLID,
        type: ChartType.LINE,
        disabled: false
    }, {
        label: 'Step line with breaks',
        subType: ChartSubType.STEP_LINE,
        style: IndicatorOutput_OutputStyle.WITH_BREAKS,
        type: ChartType.LINE,
        disabled: false
    }, {
        label: 'Step line with diamonds',
        subType: ChartSubType.STEP_LINE,
        style: IndicatorOutput_OutputStyle.WITH_DIAMONDS,
        type: ChartType.LINE,
        disabled: false
    }, {
        label: 'Step Dotted Line',
        subType: ChartSubType.STEP_LINE,
        style: IndicatorOutput_OutputStyle.DOTTED,
        type: ChartType.LINE,
        disabled: true
    }, {
        label: 'Step Dashed Line',
        subType: ChartSubType.STEP_LINE,
        style: IndicatorOutput_OutputStyle.DASHED,
        type: ChartType.LINE,
        disabled: true
    }, {
        label: 'Step Large Dashed Line',
        subType: ChartSubType.STEP_LINE,
        style: IndicatorOutput_OutputStyle.LARGE_DASHED,
        type: ChartType.LINE,
        disabled: true
    }, {
        label: 'Step Sparse Dotted Line',
        subType: ChartSubType.STEP_LINE,
        style: IndicatorOutput_OutputStyle.SPARSE_DOTTED,
        type: ChartType.LINE,
        disabled: true
    }, {
        label: 'Curved line',
        subType: ChartSubType.CURVED_LINE,
        style: IndicatorOutput_OutputStyle.SOLID,
        type: ChartType.LINE,
        disabled: false
    }, {
        label: 'Curved Dotted Line',
        subType: ChartSubType.CURVED_LINE,
        style: IndicatorOutput_OutputStyle.DOTTED,
        type: ChartType.LINE,
        disabled: true
    }, {
        label: 'Curved Dashed Line',
        subType: ChartSubType.CURVED_LINE,
        style: IndicatorOutput_OutputStyle.DASHED,
        type: ChartType.LINE,
        disabled: true
    }, {
        label: 'Curved Large Dashed Line',
        subType: ChartSubType.CURVED_LINE,
        style: IndicatorOutput_OutputStyle.LARGE_DASHED,
        type: ChartType.LINE,
        disabled: true
    }, {
        label: 'Curved Sparse Dotted Line',
        subType: ChartSubType.CURVED_LINE,
        style: IndicatorOutput_OutputStyle.SPARSE_DOTTED,
        type: ChartType.LINE,
        disabled: true
    }, {
        label: 'Area',
        subType: ChartSubType.SIMPLE,
        style: IndicatorOutput_OutputStyle.SOLID,
        type: ChartType.AREA,
        disabled: false
    }, {
        label: 'Histogram',
        subType: ChartSubType.SIMPLE,
        style: IndicatorOutput_OutputStyle.SOLID,
        type: ChartType.HISTOGRAM,
        disabled: false
    }, {
        label: 'Columns',
        subType: ChartSubType.SIMPLE,
        style: IndicatorOutput_OutputStyle.SOLID,
        type: ChartType.COLUMN,
        disabled: false
    }, {
        label: 'Cross',
        subType: ChartSubType.CROSS_LINE,
        style: IndicatorOutput_OutputStyle.SOLID,
        type: ChartType.LINE,
        disabled: false
    }, {
        label: 'Circles',
        subType: ChartSubType.CIRCLE_LINE,
        style: IndicatorOutput_OutputStyle.SOLID,
        type: ChartType.LINE,
        disabled: false
    }
]

/** Shared top/bottom padding on the main chart price scale (fraction of pane height). */
export const CHART_PRICE_SCALE_MARGINS = {
    top: 0.1,
    bottom: 0.1
} as const

export const chartLayoutOptions = {
    layout: {
        textColor: 'black',
        background: { type: ColorType.Solid, color: 'white' }
    },
    rightPriceScale: {
        visible: true,
        borderVisible: false,
        scaleMargins: CHART_PRICE_SCALE_MARGINS,
        ticksVisible: true
    },
    leftPriceScale: {
        visible: false,
        borderVisible: false,
        scaleMargins: CHART_PRICE_SCALE_MARGINS,
        ticksVisible: true
    },
    nonPrimaryPriceScale: {
        visible: true,
        borderVisible: false,
        ticksVisible: true
    },
    timeScale: {
        borderVisible: false,
        borderColor: background,
        visible: true,
        shiftVisibleRangeOnNewBar: true,
        allowShiftVisibleRangeOnWhitespaceReplacement: true,
    },
    grid: {
        horzLines: {
            color: '#D6DCDE66'
        },
        vertLines: {
            color: '#D6DCDE66'
        }
    },
    crosshair: {
        mode: CrosshairMode.Normal
    },
    handleScroll: {
        mouseWheel: true,
        pressedMouseMove: true,
        horzTouchDrag: true,
        vertTouchDrag: true
    }
} as ChartOptions

interface filterOperatorsType {
    [OPERATOR_UNKNOWN: string]: string;

    GREATER_THAN: string;
    GREATER_THAN_EQUAL_TO: string;
    LESS_THAN: string;
    LESS_THAN_EQUAL_TO: string;
    NOT_EQUAL_TO: string;
    IN: string;
    EQUAL_TO: string;
    BETWEEN: string;
    NOT_IN: string;
    MATCH: string;
}

export const filterOperators: filterOperatorsType = {
    OPERATOR_UNKNOWN: 'unknown',
    GREATER_THAN: 'Above',
    GREATER_THAN_EQUAL_TO: 'Above or Equal',
    LESS_THAN: 'Below',
    LESS_THAN_EQUAL_TO: 'Below or Equal',
    NOT_EQUAL_TO: 'Not Equal',
    IN: 'In',
    EQUAL_TO: 'Equal',
    BETWEEN: 'Between',
    NOT_IN: 'Not In',
    MATCH: 'Match',
    OUTSIDE: 'Outside'
}

export const purposeTypeMap: Record<string, string> = {
    TYPE_UNKNOWN: "Unknown",
    DIVIDEND: "Dividend",
    BOARD_MEETING: "Board Meeting",
    BONUS: "Bonus",
    FUND_RAISING: "Fund Raising",
    BUYBACK: "Buyback",
    FINANCIAL_RESULTS: "Financial Results",
    SPLIT: "Split",
    VOLUNTARY_DELISTING: "Voluntary Delisting",
    OTHER_BUSINESS_MATTERS: "Other Business Matters",
    UNRECOGNIZED: "Not enough information",
};

export const dividendTypeMap: Record<string, string> = {
    INTERIM_DIVIDEND: "Interim",
    SPECIAL_DIVIDEND: "Special",
    FINAL_DIVIDEND: "Final",
}

export const HIDDEN_COLUMN_CODES: string[] = ['security']
export const MAIN_SCREENER_COLUMN: string = 'security'
export const DOUBLE_SPAN_SCREENER_COLUMNS: string[] = ['sector']
export const TRIPLE_SPAN_SCREENER_COLUMNS: string[] = ['security']
export const SCREENER_PAGE_SIZE = 30
export const SCREENER_DISPLAY_SIZE = 30
export const Redux_Store_Version = Number(import.meta.env.VITE_REDUX_STORE_VERSION) || 0
/** Multistrike chart (page + widget): sub-minute intervals are hidden and not selectable. */
export const MULTI_STRIKE_MIN_BUCKET_SECONDS = 60
export const STRIKES_LIMIT = 2.5
export const subscriptionTags = {
    WATCHLIST: 'WATCHLIST',
    INDEX_COMPONENT: 'INDEX_COMPONENT',
    POSITION_COMPONENT: 'POSITION_COMPONENTS',
    POSITION_WIDGET_SUBSCRIPTION_TAG: 'POSITION_WIDGET',
    MULTI_STRIKES_CHART: 'MULTI_STRIKES_CHART',
    READONLY_BASKET_POSITION: 'READONLY_BASKET_POSITION',
    CHART_POC: 'CHART_POC',
    HOLDINGS_WIDGET_SUBSCRIPTION_TAG: 'HOLDINGS_WIDGET',
    ORDERS_WIDGET_SUBSCRIPTION_TAG: 'ORDERS_WIDGET'
}
export const CRORE = 10000000
export const LAKH = 100000
export const tickSize = 0.10
export const ILLIQUID_OPTION_THRESHOLD = 1
export const OPTION_CHAIN_TABLE_ID = 'option-chain-view-table'
export const MULTIPANE_FULLSCREEN_MODE_ID = 'MultiPane-FullScreen-Mode'
export const cacheNames = [
    { value: "SECURITY_CACHE_NAME", label: "SECURITY CACHE" },
    { value: "SCREENER_CACHE_NAME", label: "SCREENER CACHE" },
    { value: "BHAVCOPY_CACHE_NAME", label: "BHAVCOPY CACHE" },
    { value: "INDEX_COMPONENT_CACHE_NAME", label: "INDEX COMPONENT CACHE" },
    { value: "INDICATOR_CACHE_NAME", label: "INDICATOR CACHE" },
    { value: "OVERVIEW_WIDGET_CACHE_NAME", label: "OVERVIEW WIDGET CACHE" },
    { value: "NEWS_CACHE_NAME", label: "NEWS CACHE" },
    { value: "SUPERCHART_CONFIGURATION_CACHE_NAME", label: "SUPERCHART CONFIG CACHE" },
    { value: "SECURITY_SEARCH_INDEXER_CACHE_NAME", label: "SECURITY SEARCH INDEXER CACHE" },
    { value: "ALL_CACHE", label: "ALL CACHE" }
];
export const jobNames = [
    { value: "SECURITY_MASTER_REFRESH", label: "SECURITY MASTER REFRESH" },
    { value: "BHAVCOPY_REFRESH", label: "BHAVCOPY REFRESH" },
    { value: "SECURITY_MARGIN_REFRESH", label: "SECURITY_MARGIN_REFRESH" }
];

export const simulatorSecurities = [
    {
        exchange: 1,
        code: "NIFTY_50",
        symbol: "NIFTY",
        displayName: "Nifty 50",
        series: "XX",
        priceMultiplier: 100,
        categoryCode: 5,
        logoUrl: "nifty"
    }, {
        exchange: 1,
        code: "NIFTY_BANK",
        symbol: "BANKNIFTY",
        displayName: "Nifty Bank",
        series: "XX",
        priceMultiplier: 100,
        categoryCode: 5,
        logoUrl: "banknifty"
    }, {
        exchange: 1,
        code: "NIFTY_FIN_SERVICE",
        symbol: "FINNIFTY",
        displayName: "Nifty Fin Service",
        series: "XX",
        priceMultiplier: 100,
        categoryCode: 5,
        logoUrl: "finnifty"
    }, {
        exchange: 1,
        code: "NIFTY_MID_SELECT",
        symbol: "MIDCPNIFTY",
        displayName: "Nifty Mid Select",
        series: "XX",
        priceMultiplier: 100,
        categoryCode: 5,
        logoUrl: ""
    }, {
        exchange: 2,
        code: "SENSEX",
        symbol: "SENSEX",
        displayName: "SENSEX",
        series: "XX",
        priceMultiplier: 100,
        categoryCode: 5,
        logoUrl: "sensex"
    }, {
        exchange: 2,
        code: "BANKEX",
        symbol: "BANKEX",
        displayName: "BANKEX",
        series: "XX",
        priceMultiplier: 100,
        categoryCode: 5,
        logoUrl: "bank"
    }
]